
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent, ClientswitchComponent } from './login/index';
import { AuthGuard } from './services/index';
import { MainComponent } from './main/main.component';
import { TokensComponent } from './tokens/index';
import { StatusComponent } from './status/index';
import { StorageComponent, StorageFormComponent } from './storage/index';
import { StockcontrolComponent } from './storage/form/stockcontrol.component';
import { StockreorganisationComponent } from './storage/form/stockreorganisation.component';
import { StockupComponent } from './stockUp/stockup.component';
import { ManifestchoiceComponent, ManifestComponent } from './manifest';
import { ImportCHComponent } from './import/importCH';
import { ExportComponent } from './export';
import { ImportDEComponent } from './import/importDE';
import { GasComponent, GasArticlesComponent, NewGasArticlesComponent, GaschoiceComponent } from './gas';
import { ExceptionComponent, ExceptionFormComponent } from './exception/index';
import { ContainerComponent, ContainerFormComponent } from './container/index';
import { ShelfComponent, ShelfFormComponent } from './shelf/index';
import { SorterComponent, SorterConfigFormComponent, SorterConfigContainerFormComponent } from './sorter/index';

export const routes: Routes = [
    {
        path: '', component: MainComponent, canActivate: [AuthGuard],
        children: [
            {
                path: '', component: StatusComponent, canActivate: [AuthGuard],
            },
            {
                path: 'storage', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: StorageComponent,
                }, {
                    path: 'add',
                    component: StorageFormComponent,
                }, {
                    path: ':storageReference/edit',
                    component: StorageFormComponent,
                }, {
                    path: 'control',
                    component: StockcontrolComponent,
                }, {
                    path: 'reorganisation',
                    component: StockreorganisationComponent,
                }]
            },
            {
                path: 'stockup', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: StockupComponent,
                }, {
                    path: 'importCH',
                    component: ImportCHComponent,
                }, {
                    path: 'import/DE',
                    component: ImportDEComponent,
                }, {
                    path: 'export/DE',
                    component: ExportComponent,
                }, {
                    path: 'export/CH',
                    component: ExportComponent,
                }]
            },
            {
                path: 'manifestchoice', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: ManifestchoiceComponent,
                }, {
                    path: 'manifest/exportCH',
                    component: ManifestComponent,
                }, {
                    path: 'manifest/exportDE',
                    component: ManifestComponent,
                }, {
                    path: 'manifest/importDE',
                    component: ManifestComponent,
                }]
            },
            {
                path: 'gaschoice', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: GaschoiceComponent,
                }, {
                    path: 'gas',
                    component: GasComponent,
                }]
            },
            {
                path: 'container', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: ContainerComponent,
                }, {
                    path: 'add',
                    component: ContainerFormComponent,
                }, {
                    path: ':containerName/edit',
                    component: ContainerFormComponent,
                }]
            },
            {
                path: 'shelf', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: ShelfComponent,
                }, {
                    path: 'add',
                    component: ShelfFormComponent,
                }]
            },
            {
                path: 'exception', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: ExceptionComponent,
                },
                {
                    path: 'add',
                    component: ExceptionFormComponent,
                },
                {
                    path: ':exceptionType/:exceptionCode/edit',
                    component: ExceptionFormComponent,
                }
            ]
            },
            {
                path: 'sorter', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: SorterComponent,
                },
                {
                    path: ':containerName/:channel/:storage/:sorterName/edit',
                    component: SorterConfigContainerFormComponent,
                },
                {
                    path: ':prio/edit',
                    component: SorterConfigFormComponent,
                },
                {
                    path: 'add',
                    component: SorterConfigFormComponent,
                }
            ]
            },
            {
                path: 'importCH', component: ImportCHComponent, canActivate: [AuthGuard],
            },
            {
                path: 'manifest/exportDE', component: ManifestComponent, canActivate: [AuthGuard],
            },
            {
                path: 'manifest/exportCH', component: ManifestComponent, canActivate: [AuthGuard],
            },
            {
                path: 'manifest/importDE', component: ManifestComponent, canActivate: [AuthGuard],
            },
            {
                path: 'gas', component: GasComponent, canActivate: [AuthGuard],
            },
            {
                path: 'tokens', canActivate: [AuthGuard],
                children: [{
                    path: '',
                    component: TokensComponent,
                }]
            }
        ]
    },
    { path: 'login', component: LoginComponent },


    // otherwise redirect to home
    { path: '**', redirectTo: '' },

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);

export const routedComponents: any[] = [
    MainComponent, LoginComponent, ClientswitchComponent,
    StatusComponent,
    TokensComponent,
    StorageComponent, StorageFormComponent, 
    StockcontrolComponent,
    StockreorganisationComponent,
    StockupComponent,
    ManifestchoiceComponent,
    GaschoiceComponent,
    ContainerComponent, ContainerFormComponent,
    ImportCHComponent,
    ExportComponent,
    ImportDEComponent,
    ManifestComponent,
    GasComponent, GasArticlesComponent, NewGasArticlesComponent,
    ExceptionComponent, ExceptionFormComponent,
    ShelfComponent, ShelfFormComponent, 
    SorterComponent, SorterConfigFormComponent, SorterConfigContainerFormComponent
];




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/app.routes.ts